// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 客户申请电子券 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /gift/coupon/apply */
export async function giftCouponApplyUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.giftCouponApplyUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListGiftOrderInfoResp>('/gift/coupon/apply', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 礼赠奖品列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /gift/coupon/list */
export async function giftCouponListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListGiftCouponResp>('/gift/coupon/list', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 客户领取电子券 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /gift/coupon/receive */
export async function giftCouponReceiveUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.giftCouponReceiveUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/gift/coupon/receive', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 礼赠领取信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /gift/coupon/receive/detail */
export async function giftCouponReceiveDetailUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.giftCouponReceiveDetailUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultGiftCouponResp>('/gift/coupon/receive/detail', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
